import CollapsableComponent from '@components/CollapsableComponent';
import QuillHtmlComponent from '@components/QuillHtmlEditorComponent';
import HtmlEditorComponent from '@components/richText/htmlEditorComponent';
import { Notification } from '@interfaces/global/notification';
import { NotificationType } from '@interfaces/global/notification-type';
import { NotificationEmail } from '@interfaces/global/notification/email';
import { NotificationPush } from '@interfaces/global/notification/push';
import { NotificationSMS } from '@interfaces/global/notification/sms';
import NotificationService from '@services/global/Notification';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Button, Card, Checkbox, Col, Dropdown, Icon, Input, Menu, message, Row } from 'antd';
import React from 'react';

const CheckboxGroup = Checkbox.Group;

interface IProp {
  notificationToOpen?: Notification
  pillar: any
  senderOptions: any[]
  onDelete: Function
  onCreate: Function
  onUpdate: Function
  closeModal: Function
}

interface IState {
  saving: boolean;
  showingAdvancedOptions: boolean;
  senderOptions: any[],
  keyOptions: any[],
  somethingHasChanged: boolean,
  canSave: boolean,
  notification: Notification | undefined,
  isDeleting: boolean
}

class NotificationRegisterCardComponent extends React.Component<IProp, IState> {
  private _notificationService: NotificationService = new NotificationService(this.props.pillar);

  constructor(props: IProp) {
    super(props);

    this.state = {
      saving: false,
      showingAdvancedOptions: false,
      senderOptions: this.props.senderOptions,
      keyOptions: [],
      somethingHasChanged: false,
      canSave: false,
      notification: this.props.notificationToOpen,
      isDeleting: false
    }
  }
  
  componentDidMount(){
    console.log('VALOR INICIAL', this.state.notification)
  }

  createNotification = async (notification: Notification | NotificationEmail | NotificationSMS | NotificationPush) => {
    switch (notification.type) {
      case NotificationType.EMAIL:
        return await this._notificationService.createEmail(notification as NotificationEmail);

      case NotificationType.SMS:
        return await this._notificationService.createSMS(notification as NotificationSMS);

      case NotificationType.PUSH:
        return await this._notificationService.createPush(notification as NotificationPush);

      default:
        console.error("Notification type uknown: ", notification);
        return [];
    }
  }

  deleteNotification = async (idToDelete: string, notificationType: NotificationType) => {
    switch (notificationType) {
      case NotificationType.EMAIL:
        return await this._notificationService.deleteEmailById(idToDelete);

      case NotificationType.SMS:
        return await this._notificationService.deleteSMSById(idToDelete);

      case NotificationType.PUSH:
        return await this._notificationService.deletePushById(idToDelete);

      default:
        console.error("Notification type uknown: ", notificationType);
        return [];
    }
  }

  updateNotification = async (notification: Notification | NotificationEmail | NotificationSMS | NotificationPush) => {
    switch (notification.type) {
      case NotificationType.EMAIL:
        return await this._notificationService.updateEmailById(notification.id, notification as NotificationEmail);

      case NotificationType.SMS:
        return await this._notificationService.updateSMSById(notification.id, notification as NotificationSMS);

      case NotificationType.PUSH:
        return await this._notificationService.updatePushById(notification.id, notification as NotificationPush);

      default:
        console.error("Notification type uknown: ", notification);
        return [];
    }
  }

  setAdvanced(newValue: boolean) {
    //console.log("Tooggling showing advanced options!", newValue);
    this.setState({ showingAdvancedOptions: newValue });
  }

  onNotificationSelected(e: any) {
    console.log(`checked = ${e.target.checked}`);
  }

  onDropDownSelected(selectorClicked: string) {
    console.log(selectorClicked);
  }

  onKeysListOptionsClicked = async (key: string) => {
    console.log(key);
  }

  getSenderOptions(pillar: any, client: any) {
    let checkboxOptions = [];

    switch (pillar) {
      case "QAFS":
        checkboxOptions.push({
          label: client.name, value: 1
        }, {
            label: I18n.l('labels.distributor'), value: 2
          }, {
            label: I18n.l('labels.agent'), value: 3
          })
        break;

      case "EHSS":
        checkboxOptions.push({
          label: I18n.l('labels.auditor'), value: 2
        }, {
            label: I18n.l('labels.audited'), value: 1
          })
        break;

      default:
        checkboxOptions.push({
          label: "@Pillar Not Implement", value: 2
        })
        break;
    }
    return (checkboxOptions);
  }

  getSenderOptionsDefautValue(notification?: Notification) {
    if (notification != undefined) {

      // console.log(notification);
      let defaultValues: number[] = [];
      if (notification.profiles.length > 0) {
        defaultValues = notification.profiles;
      }
      // console.log(defaultValues);
      return defaultValues;
    }
    else {
      console.error("Notification Undefined")
      return undefined;
    }
  }

  getKeyListOptions(keyList?: string[]) {
    if (keyList !== undefined) {
      return (
        <Menu>
          {
            // console.log("Keys to show: ", keyList)
          }
          {
            (keyList.length > 0) && keyList.map((key: string, i: number) => {
              return (
                <Menu.Item key={i} onClick={() => this.onKeysListOptionsClicked(key)}>
                  <p>{key}</p>
                </Menu.Item>
              )
            })
          }
        </Menu>
      )
    } else {
      return (<div></div>)
    }
  }

  setSomethingHasChanged = async () => {
    this.setState({ somethingHasChanged: true });
  }

  onContentHasChanged = async (e: any) => {
    let newNotification: any = this.state.notification;

    const data = {
      id: newNotification.id,
      name: newNotification.subject,
      subject: newNotification.subject,
      content: e,
      profiles: newNotification.profiles,
      keys: newNotification.keys,
      type: newNotification.type
    }

    this.setState({ notification: data, somethingHasChanged: true })
    console.log('e.target.value', this.state.notification);
    this.onValidate(this.state.notification);
  }

  onSubjectHasChanged = async (e: any) => {
    // console.log(e.target.value);
    const newNotification: any = this.state.notification;

    const data = {
      id: newNotification.id,
      name: e.target.value,
      subject: e.target.value,
      content: newNotification.content,
      profiles: newNotification.profiles,
      keys: newNotification.keys,
      type: newNotification.type
    };;

    this.setState({ notification: data, somethingHasChanged: true })
    this.onValidate(this.state.notification);
  }

  onSelectedHasChanged = async (checkedValues: any) => {
    // console.log('checked = ', checkedValues);

    let newNotification: any = this.state.notification;

    const data = {
      id: newNotification.id,
      name: newNotification.name,
      subject: newNotification.subject,
      content: newNotification.content,
      profiles: checkedValues,
      keys: newNotification.keys,
      type: newNotification.type
    }

    this.setState({ notification: data, somethingHasChanged: true })
    this.onValidate(this.state.notification);
  }
  onValidate = async (notification: Notification | undefined) => {

    if (notification === undefined)
      return;

    let contentHasError: boolean = false;
    let subjecttHasError: boolean = false;
    let selectedHasError: boolean = false;

    if (notification.content != undefined) {
      contentHasError = (notification.content.length == 0)
    }
    if (notification.subject != undefined) {
      subjecttHasError = (notification.subject.length == 0)
    }
    if (notification.profiles != undefined) {
      selectedHasError = (notification.profiles.length == 0)
    }

    this.setState({ canSave: !(contentHasError || subjecttHasError || selectedHasError) })
    // console.log("Can Save: ", this.state.canSave);
  }

  createNew = async (notificationToCreate: Notification | undefined) => {

    if (notificationToCreate === undefined)
      return;

    const notification: Notification = {
      name: notificationToCreate.name,
      subject: notificationToCreate.subject,
      content: notificationToCreate.content,
      profiles: notificationToCreate.profiles,
      keys: notificationToCreate.keys,
      type: notificationToCreate.type
    }

    console.log("Notification to create: ", notification);

    this.setState({ saving: true });
    try {
      const notificationCreated = await this.createNotification(notification);
      

      this.setState({
        saving: false,
        canSave: false,
        somethingHasChanged: false
      });
      message.success(I18n.l('titles.notificationCreate'), 3);
      this.props.onCreate(notificationCreated);
      this.props.closeModal()
      await this.discardChanges();
    } catch (error) {
      message.error(error, 3);
      this.setState({
        saving: false,
      });
    }
  }

  updateEmail = async (notificationToUpdate: Notification | undefined) => {

    console.log("updating");
    if (notificationToUpdate === undefined) {
      console.log("notification update not found");
      return;
    }

    if (notificationToUpdate.id === undefined) {
      console.log("notification update ID not found");
      return;
    }

    console.log("starting saving");
    this.setState({ saving: true });
    console.log("starting saving ended");

    if (notificationToUpdate !== undefined) {
      try {
        console.log("Calling update");
        const data = await this.updateNotification(notificationToUpdate);
        console.log(data);
        console.log("End update");

        this.setState({
          saving: false,
          canSave: false,
          somethingHasChanged: false
        });

        message.success(I18n.l('titles.notificationUpdate'), 3);
        this.props.onUpdate(notificationToUpdate);
        this.props.closeModal()
      } catch (error) {
        message.error(error, 3);
        this.setState({
          saving: false,
        });
      }
    }
  }

  deleteEmail = async (notificationToDelete: Notification | undefined) => {

    if (notificationToDelete === undefined)
      return;

    const idToDelete: string = notificationToDelete.id || "";

    this.setState({ saving: true });
    try {
      if (idToDelete !== '') {
        await this.deleteNotification(idToDelete, notificationToDelete.type);
        this.setState({
          saving: false,
          canSave: false,
          somethingHasChanged: false
        });
        message.success(I18n.l('titles.notificationDelete'), 3);
        this.props.onDelete(notificationToDelete.id);
      }
      else {
        this.props.onDelete();
      }

    } catch (error) {
      message.error(error, 3);
      this.setState({
        saving: false,
      });
    }
  };

  discardChanges = async () => {
    console.log("Discarding values");
    let currentInitialValues = this.props.notificationToOpen;

    this.setState({
      canSave: false,
      somethingHasChanged: false,
      notification: currentInitialValues
    })

    if (this.refs.subjectfield !== undefined) {
      this.refs.subjectfield.input.value = this.state.notification ? this.state.notification.subject : "";
    }

    if (this.refs.contentfield !== undefined) {
      this.refs.contentfield.textAreaRef.value = this.state.notification ? this.state.notification.content : "";
    }

    //console.log("Checkbox Group: ", this.refs.selectedfield);

    //console.log(this.state.sendersSubject)
  }

  toggleDeleting = async (value: boolean) => {
    this.setState({
      isDeleting: value
    })
  }

  render() {
    const {
      showingAdvancedOptions,
      somethingHasChanged,
      canSave,
      senderOptions,
      isDeleting
    } = this.state;

    const isRichtText: boolean = false;
    return (
      <div>
        <NotificationComponent>
          <Col sm={24} md={24} xl={24}>
            <div>

              <Col sm={24} md={24} xl={24} className="goepik-top-margin">
                <Card className="goepik-notification-card">
                  <Row type="flex" justify="end">
                    <Col>
                      <DeleteButtonsStyle>
                        {(!isDeleting) && <Button type="primary" ghost size={"small"} onClick={() => this.toggleDeleting(true)}>{I18n.l("notificationcard.delete")}</Button>}
                        {(isDeleting) && <Button type="primary" ghost size={"small"} onClick={() => this.deleteEmail(this.state.notification)}>{I18n.l("common.delete")}</Button>}
                        {(isDeleting) && <span>/</span>}
                        {(isDeleting) && <Button type="primary" ghost size={"small"} onClick={() => this.toggleDeleting(false)}>{I18n.l("common.cancel")} </Button>}
                      </DeleteButtonsStyle>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={24} md={24} xl={24}>
                      <SenderStyle>
                        <p>{I18n.l("titles.sendTitle")}</p>
                        <CheckboxGroup
                          ref={"selectedfield"}
                          value={this.state.notification ? this.state.notification.profiles : undefined}
                          defaultValue={this.state.notification ? this.state.notification.profiles : undefined}
                          options={senderOptions}
                          onChange={this.onSelectedHasChanged}
                        />
                      </SenderStyle>
                    </Col>
                  </Row>
                  {(this.state.notification ? this.state.notification.keys != undefined : false) &&
                    <Row>
                      <Col sm={24} md={24} xl={24}>
                        <DataSelectorStyle>
                          <CollapsableComponent title={I18n.l("notificationcard.advancedoptions")} collapsed={!showingAdvancedOptions} onClick={() => this.setAdvanced(!showingAdvancedOptions)}>
                            <div>
                              <p>{I18n.l("notificationcard.collapsedmessage")}</p>
                              <Dropdown overlay={this.getKeyListOptions(this.state.notification !== undefined ? this.state.notification.keys : undefined)}>

                                <Button>
                                  {I18n.l("titles.selectOption")} <Icon type="down" />
                                </Button>

                              </Dropdown>
                            </div>
                          </CollapsableComponent>
                        </DataSelectorStyle>
                      </Col>
                    </Row>
                  }
                  <Row>
                    <Col sm={24} md={24} xl={24}>
                      <Card className="goepik-notification-card goepik-notify-card-title">
                        <Row>
                          <Col sm={24} md={24} xl={24}>
                            <Input ref={"subjectfield"} defaultValue={this.state.notification ? this.state.notification.subject.toString() : ""} className="notification-title" onChange={this.onSubjectHasChanged} />
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={24} md={24} xl={24}>
                      <Card className="goepik-notification-card goepik-notify-inner-card goepik-notify-card-title">
                        {
                          (isRichtText) &&
                          <HtmlEditorComponent />
                        }

                        {
                          (!isRichtText) &&
                          <QuillHtmlComponent
                            defaultValue={this.state.notification ? this.state.notification.content : ""}
                            onTextChange={this.onContentHasChanged}
                          />
                          // <TextArea ref={"contentfield"} rows={4} defaultValue={this.state.notification ? this.state.notification.content : ""} onChange={this.onContentHasChanged} />
                        }
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={24} md={24} xl={24}>
                      {(this.state.notification != undefined) &&
                        <NotificationFooterButtons>
                          <Button type="primary" ghost disabled={!(somethingHasChanged && canSave) || (this.state.saving)} onClick={this.state.notification.id ===  '' ?() => this.createNew(this.state.notification) : () => this.updateEmail(this.state.notification) }>{I18n.l("common.create").toUpperCase()}</Button>
                          {/* <Button type="primary" ghost onClick={() => this.updateEmail(this.state.notification)}>{I18n.l("common.overwrite").toUpperCase()}</Button>
                          <Button type="primary" ghost disabled={!somethingHasChanged || this.state.saving} onClick={() => this.discardChanges()}>{I18n.l("common.discard").toUpperCase()}</Button> */}
                        </NotificationFooterButtons>
                      }
                      {(this.state.notification == undefined) &&
                        <NotificationFooterButtons>
                          <Button type="primary" ghost disabled={!(somethingHasChanged && canSave)}>{I18n.l("common.create").toUpperCase()}</Button>
                          <Button type="primary" ghost disabled={somethingHasChanged}>{I18n.l("common.discard").toUpperCase()}</Button>
                        </NotificationFooterButtons>
                      }
                    </Col>
                  </Row>
                </Card>
              </Col>
            </div>
          </Col>
        </NotificationComponent>
      </div>
    );
  };
}


const DeleteButtonsStyle = styled.div`
    .ant-btn{
        font-weight: bold;
        color: ${Theme.standard.red} !important;
    }
`;

const NotificationFooterButtons = styled.div`
    margin: 5px 5px 5px 0px;
`;

const SenderStyle = styled.div`
    margin-top:25px;
    margin-left:15px;
`;

const DataSelectorStyle = styled.div`
    margin-top:25px;
    margin-left:15px;
`;

const NotificationComponent = styled.div`
    .goepik-top-margin{
        margin-top: 4%!important;
    }
    
    .goepik-card-space{
        margin-right: 4%;
    }

    .goepik-notification-card{
        .ant-card-body{
            padding-top: 0!important;
            padding-bottom: 0!important;
            padding-left: 0.7em;
            padding-right: 0.7em;
            border-style: solid;
            border-width: 1px;
            border-radius: 10px;
            padding: 10px;
            border-color: ${Theme.standard.lightGray};
        }

        .goepik-notify-card-title{
            margin-top: 0.5em;
            margin-bottom: 0.5em;
        }

        .notification-title{
            margin-bottom: 10px;
            margin-top: 10px;
            font-weight: 700;
            font-size: larger;
        }
    }

    .goepik-notify-inner-card{
        .ant-card-body{
            padding-left: 0!important;
            padding-right: 0!important;
        }import { NotificationSMS } from '@interfaces/global/notification/sms';
import { NotificationPush } from '@interfaces/global/notification/push';


    }
`;

export default NotificationRegisterCardComponent;

